import { useGetCampaignContractorFilter, useGetCampaigns } from 'entities/campaign';
import { getPageUiStates } from 'shared/lib/api';
import { useGetContractor } from 'entities/profile';
import { Loader } from 'shared/ui/Loader';
import { PageError } from 'shared/ui/PageError';
import type { ContractorCampaignModel } from 'entities/campaign';

import { AddCardBlock } from './AddCardBlock';
import { ContractorCampaignsTable } from './ContractorCampaignsTable';
import { Filters } from './Filters';

interface ContractorCampaignsViewAllProps {
  isOnboarding: boolean;
  onTableRowClick: ({ id }: { id: number }) => void;
}

export function ContractorCampaignsViewAll(props: ContractorCampaignsViewAllProps) {
  const { onTableRowClick, isOnboarding } = props;

  const filtersFromURL = useGetCampaignContractorFilter();
  const getCampaignsQuery = useGetCampaigns<ContractorCampaignModel>({ urlFilters: filtersFromURL });
  const userQuery = useGetContractor();

  const pageStates = getPageUiStates([getCampaignsQuery, userQuery]);

  const user = userQuery.data?.data;
  const isAddCardBlockShown = !user?.hasCreditCard && user?.paymentMethod === 'stripe' && !isOnboarding;

  if (pageStates.isTableLoading) {
    return <Loader className="mt-20 flex justify-center" />;
  }

  return (
    <>
      <Filters />
      {pageStates.hasErrors && (
        <div className="mt-6">
          <PageError />
        </div>
      )}
      {!pageStates.hasErrors && (
        <>
          {isAddCardBlockShown && (
            <AddCardBlock
              refetchUserData={userQuery.refetch}
              className="-mb-2 mt-6"
            />
          )}
          <ContractorCampaignsTable
            data={getCampaignsQuery.data}
            isLoading={pageStates.isTableFetching}
            onTableRowClick={onTableRowClick}
          />
        </>
      )}
    </>
  );
}
